import orderBy from 'lodash/orderBy';

import { enum as payoutStatuses } from '../../../../../../../enums/payout-statuses';

export default function sortRows(rows, sorting) {
	if (sorting.index === 'is_urgent') {
		return orderBy(
			rows,
			[
				row => row.payload.is_urgent,
				row => statusWeights[row.payload.status],
				row => row.payload.created_at
			],
			[sorting.direction, 'desc', 'asc']
		);
	}

	return orderBy(rows, getSortBy(sorting), sorting.direction);
}

// weights of statuses are similar to weights of statuses on server
const statusWeights = {
	[payoutStatuses.approved]: 5,
	[payoutStatuses.pending]: 4,
	[payoutStatuses.confirmed]: 3,
	[payoutStatuses.paid]: 2,
	[payoutStatuses.rejected]: 1
};

function getSortBy(sorting) {
	switch (sorting.index) {
		case 'is_urgent':
			return row => row.payload.is_urgent;
		case 'date':
			return row => row.payload.created_at;
		case 'status':
			return row => statusWeights[row.payload.status];
		case 'affiliate':
			return row => row.affiliate.email;
		case 'amount':
			return row => row.payload.amount;
		case 'amount_to_pay':
			return row => row.payload.amount_to_pay;
		case 'paid_at':
			return row => sorting.direction === 'desc'
				? row.payload.paid_at || '' // null at the end
				: row.payload.paid_at;
		case 'paid':
			return row => row.affiliate.paid_payouts_count;
	}
}


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/list/helpers/sort-rows.js